





















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { Customer } from "@/entity/Net20/Customer";
import CustomerData from "./modules/CustomerData.vue";
import { i18n } from "@/i18n/i18n-setup";
import { ContractStep, getStepsDescription, STEP_ENUM } from "@/entity/Net20/ContractStep";
import StepProgressCustom from '@/components/Utilities/StepProgressCustom.vue';
import Step from '@/interfaces/IStep';
import { Contract, GetContractTypeDefinition } from "@/entity/Net20/Contract";
import CustomerSocials from "./modules/CustomerSocials.vue";
import CustomerServices from "./modules/CustomerServices.vue";
import CustomerContracts from "./modules/CustomerContracts.vue";
import ContractNextStep from "./modules/ContractNextStep.vue";
import { NET20_AUTHORIZATION, NET20_CONTRACT_TYPE } from "@/services/Enums";
import ContractRenewal from "./modules/ContractRenewal.vue";
import { ContractAttachment } from "@/entity/Net20/ContractAttachment";
import EntityHistoryDetail from "../EntityHistoryDetail.vue";
import { DropDownItem } from "@/services/DropDownItem";
import { IsPotentialVolumeCompliant, SOURCE, GetExcludedContractSteps, GetFieldConfigurations, IsMandatoryField, GetDistricts } from "@/services/Net20DropDowns";
import { GetDropDownChannels } from "@/entity/Net20/Channel";
import ContractStepBack from "./modules/ContractStepBack.vue";
import { FieldConfiguration } from "@/entity/Net20/FieldConfiguration";
import { ClaimEnum } from "@/services/ClaimEnum";

@Component({
  components: {
    CustomerData,
    StepProgressCustom,
    CustomerSocials,
    CustomerServices,
    CustomerContracts,
    ContractNextStep,
    ContractRenewal,
    EntityHistoryDetail,
    ContractStepBack
  }
})
export default class CustomerDetails extends Vue {
  @Prop({ type: Boolean, required: false })
  editMode;
  @Prop({ type: String, required: false })
  contractId;
  @Prop({ type: String, required: false })
  idCustomer;
  @Prop({ type: Array, required: false })
  dropDownTypeOfProposalProp: Array<any>;
  @Prop({ type: Array, required: false })
  dropDownChannelProp: Array<any>;

  authorizedUser: boolean = true;
  parentMounted: boolean = false;
  loading: boolean = false;
  customer: Customer = new Customer();
  countryListData: Array<any> = [];
  selectedContract: Contract = new Contract();
  selectedContractId: string = '';
  dropDownContractYears: Array<any> = new Array<any>();
  dropDownCountries: Array<any> = [];
  dropDownTypeOfProposal: Array<any> = [];
  dropDownChannel: Array<any> = [];
  stepsList: Array<Step> = new Array<Step>();

  tabActivated: number = 0;
  isSaveClicked: boolean = false;
  loadingScore: boolean = false;
  btnSaveLabel: string = "";
  
  forceTabContractUpdate: number = 0;
  refuseContract: boolean = false;
  previousStep: boolean = false;
  lastStepBeforeRefuse: number = 0;
  isContractRefusable: boolean = false;

  customerDataEditable: boolean = false;
  contractInfoEditable: boolean = false;
  contractSignInfoEditable: boolean = false;
  attachmentUpload: boolean = false;
  attachmentDeleteAllowed: boolean = false;
  nextStepAllowed: boolean = false;
  refuseAllowed: boolean = false;
  previousStepAllowed: boolean = false;
  renewContractAllowed: boolean = false;
  renewalsCounter: number = 0;

  nextStepModalTitle: string = "";
  STEP_ENUM_LIST = STEP_ENUM;

  fieldConfigurations: Array<FieldConfiguration> = new Array();
  isCountryWithDistricts: boolean = null;

  async updateAttachments(attachments: ContractAttachment[], contractId: string) {
    await axios({
      method: "post",
      url: General.GetApiUrl("/api/net20/UpdateContractAttachments?contractId=" + contractId),
      data: attachments,
      withCredentials: true,
      responseType: "json",
    });
  }

  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll, true);
  // }

  // handleScroll(event){
  //   let stickyDiv = document.getElementById("stickyDiv")
  //   if(event.target.scrollTop > 24) {
  //     stickyDiv.classList.add("stickyScrolled")
  //   } else {
  //     stickyDiv.classList.remove("stickyScrolled")
  //   }
  // }

  changeTab(){
    let app = this;
    setTimeout(()=>{
        let obj = app.$refs['customerDataObj'] as any;
        obj.forceRefresh();
      }
      ,200);
    
  }

  async onCountryChange(idCountry, fieldConfigurations, isCountryWithDistricts) {
    this.customer.excludedContractSteps = await GetExcludedContractSteps(idCountry);
    this.stepsList = getStepsDescription(0, this.customer.excludedContractSteps);

    this.fieldConfigurations = fieldConfigurations;
    this.isCountryWithDistricts = isCountryWithDistricts;
  }

  async mounted() {
    // window.addEventListener('scroll', this.handleScroll, true);

    this.loading = true;

    if(this.dropDownTypeOfProposalProp == null) {
      //Recupero la lista includendo i valori dismessi per la ricerca
      this.dropDownTypeOfProposal = await General.GetDropdownList(SOURCE.TYPE_OF_PROPOSAL);      
    } else {
      this.dropDownTypeOfProposal = this.dropDownTypeOfProposalProp;
    }

    if(this.dropDownChannelProp == null) {
      this.dropDownChannel = await GetDropDownChannels();
    } else {
      this.dropDownChannel = this.dropDownChannelProp;
    }

    if(this.idCustomer != null) {    
      this.dropDownCountries = await this.getDropdownCountries(false);
      await this.getCustomerById(this.idCustomer); 
      if(this.authorizedUser) {
        this.setFormAuthorization();
        this.stepsList = getStepsDescription(this.selectedContract.idStep, this.customer.excludedContractSteps);    
        this.lastStepBeforeRefuse = this.getLastStepBeforeRefuse();
        this.selectTabByContractStep();
        this.getRenewalsCounter();

        this.loading = false;
        this.parentMounted = true;
      }
    } else {        
      this.dropDownCountries = await this.getDropdownCountries(true);
      this.customerDataEditable = true;
      this.contractInfoEditable = true;
      this.contractSignInfoEditable = true;
      this.attachmentUpload = true;
      this.nextStepAllowed = true;

      this.customer.services = [];
      this.customer.socials = [];
      this.customer.contracts = [];
      this.selectedContract.idStep = 1;
      this.selectedContract.attachments = [];
      this.selectedContract.steps = [];
      this.stepsList = getStepsDescription(0);    
      this.$emit('onSelectingContract', this.selectedContract, false);

      this.loading = false; 
      this.parentMounted = true;      
    }

    this.setBtnSaveLabel();  
  }

  getRenewalsCounter() {
    this.renewalsCounter = this.customer.contracts.filter(x => x.contractType == NET20_CONTRACT_TYPE.RENEWAL).length;
  }

  selectTabByContractStep() {
    if(this.selectedContract.idStep >= STEP_ENUM.CONTRACT_UPLOAD && this.selectedContract.idStep <= STEP_ENUM.INSTALLED_SIGNAGE)
      this.tabActivated = 1;
  }

  async getDropdownCountries(asSalesmanOnly: boolean): Promise<Array<any>> {
      try{
          let country: DropDownItem = new DropDownItem();
          let countryList: DropDownItem[] = [];

          let response = await axios.get<any[]>(
              General.GetApiUrl('/api/net20/GetCountriesForUser?asSalesmanOnly=' + asSalesmanOnly),{
              responseType: "json",
              withCredentials: true
          });
          this.countryListData = response.data;
          if(response.data) {
              response.data.forEach( element => {
                  country = new DropDownItem();
                  country.idDropDownItem = element.idCountry;
                  country.itemText = element.name;

                  countryList.push(country);
              });
              return General.SetOptionsDropDown(countryList);
          }
      } catch(ex) {
          General.HandleError(ex, this);
          return null;
      }
  }

  setBtnSaveLabel() {
    if(this.selectedContract.idStep == STEP_ENUM.APPROVAL) {
      this.btnSaveLabel = i18n.t("NET20.BUTTON_SAVE_AND_APPROVE") as string;
    } else if(this.selectedContract.idStep == STEP_ENUM.SIGNAGE_ORDER) {
      this.btnSaveLabel = i18n.t("NET20.BUTTON_SAVE_AND_ORDER_SIGN") as string;
    } else if(this.selectedContract.idStep == STEP_ENUM.INSTALLED_SIGNAGE) {
      this.btnSaveLabel = i18n.t("NET20.BUTTON_SAVE_AND_CLOSE") as string;
    } else {
      this.btnSaveLabel = i18n.t("NET20.BUTTON_SAVE_PROCEED") as string;
    }
  }

  setFormAuthorization() {
    this.resetFormAuthorization();
    if(this.selectedContract.authorization.customerData === NET20_AUTHORIZATION.WRITE) {
      this.customerDataEditable = true;
    }
    if(this.selectedContract.authorization.contractInfo === NET20_AUTHORIZATION.WRITE) {
      this.contractInfoEditable = true;
    }
    if(this.selectedContract.authorization.contractSignInfo === NET20_AUTHORIZATION.WRITE) {
      this.contractSignInfoEditable = true;
    }
    if(this.selectedContract.authorization.attachmentUpload === NET20_AUTHORIZATION.WRITE) {
      this.attachmentUpload = true;
    }
    this.nextStepAllowed = this.selectedContract.authorization.nextStepAllowed;
    this.refuseAllowed = this.selectedContract.authorization.refuseAllowed;
    this.previousStepAllowed = this.selectedContract.authorization.previousStepAllowed;
    this.renewContractAllowed = this.selectedContract.authorization.renewContractAllowed;
    this.attachmentDeleteAllowed = this.selectedContract.authorization.attachmentDeleteAllowed;
  }

  resetFormAuthorization() {
    this.customerDataEditable = false;
    this.contractInfoEditable = false;
    this.contractSignInfoEditable = false;
    this.attachmentUpload = false;
    this.nextStepAllowed = false;
    this.refuseAllowed = false;
    this.previousStepAllowed = false;
    this.attachmentDeleteAllowed = false;
  }

  getLastStepBeforeRefuse(): number {
    let lastStep = 0;
    if(this.selectedContract.steps.length > 0 && this.selectedContract.idStep == STEP_ENUM.REFUSED) {
      let lastStepsBeforeRefuse = this.selectedContract.steps.filter(s => s.idStep != STEP_ENUM.REFUSED).map(s => s.idStep);
      lastStep = lastStepsBeforeRefuse[0];
    }
    return lastStep;
  }

  changeSelectedContract(selectedId: string = ""){
    this.selectContract(selectedId);
    this.setFormAuthorization(); 
    this.stepsList = getStepsDescription(this.selectedContract.idStep, this.customer.excludedContractSteps); 
    this.lastStepBeforeRefuse = this.getLastStepBeforeRefuse();   
    this.purgeNotUploadedAttachments();
    this.selectTabByContractStep();
    this.forceTabContractUpdate = this.forceTabContractUpdate + 1;
  }

  purgeNotUploadedAttachments() {
    this.selectedContract.attachments = this.selectedContract.attachments.filter(a => a.id != null || a.id !== undefined);
  }

  selectContract(selectedId: string = "") {
    if(selectedId === "") {
      this.selectedContractId = this.contractId;
    } else {
      this.selectedContractId = selectedId;
    }

    let index = this.customer.contracts.findIndex(c => c.id === this.selectedContractId);
    if(index >= 0)
      this.selectedContract =  this.customer.contracts[index];
    else
      this.selectedContract =  this.customer.contracts[0];

    if(this.selectedContractId === undefined)
      this.selectedContractId = this.selectedContract.id;

    if(this.selectedContract.contractType == NET20_CONTRACT_TYPE.RENEWAL)
      this.$emit('onSelectingContract', this.selectedContract, true);
    else
      this.$emit('onSelectingContract', this.selectedContract, false);
  }

  getOrderedContractList() {
      return this.customer.contracts.sort((c1,c2) => {
          if (c1.contractYear < c2.contractYear)
              return 1;

          if (c1.contractYear > c2.contractYear)
              return -1;

          return 0;
        });
  }

  initDropDownContractYears(){
    this.customer.contracts.forEach(c => {
      let contractTypeDefinition = GetContractTypeDefinition(c);
      this.dropDownContractYears.push({ value: c.id, text: contractTypeDefinition });
    })
  }

  returnState(condition: boolean, clickButton: boolean): boolean {
    if (clickButton ) 
      return condition;
    else 
      return null;
  }

  toBool(a: any) {
    var converted = false;
    if(a === undefined || a === "" || a == null) {
      converted =  false;
    }
    else {
      if(a === "true")
        converted = true;
    }
    return converted
  }

  async getCustomerById(idCustomer: string) {
    
    try {
      let response = await axios({
        method: "get",
        url: General.GetApiUrl("/api/net20/GetCustomerById?customerId=" + this.idCustomer),
        withCredentials: true,
        responseType: "json",
      });     
      this.customer = response.data;

      this.initDropDownContractYears();
      this.selectContract();
    } catch (error) {
      if(error.response.status == 403) {
        this.parentMounted = false;
        this.authorizedUser = false;
        this.$emit("unauthorized");
      } else {
        General.HandleError(error, this);
        this.parentMounted = false;
      }
    }
  }

  async saveAsDraft() {
    General.confirm(
      i18n.t('GENERIC.CONFIRM_MESSAGE') as string,
      this,
      async () => {
        await this.saveAsDraftDo();
      }
    );
  }

  async saveAsDraftDo() {
    this.isSaveClicked = true;
    let isValidServiceData = await this.isValidServicesData();

    if(!isValidServiceData) {
        this.tabActivated = 0;
        General.showAlertDanger(i18n.t('NET20.SERVICE_MANDATORY') as string, this);
    } else {
      let isValidForm = await this.isValidForm();
      if(isValidForm) {
        if(await this.showWarningLimits() && !this.checkBypassValidation()) {
            General.showAlertDanger(i18n.t('NET20.POTENTIAL_VOLUME_WARNING') as string, this);
        } else {
          if(this.customer.id != null) {
            this.loading = true;
            this.$emit("onExecutingAction");

            let vatNumberError = await this.updateNet20Entities();
            if(!vatNumberError) {
              General.showAlertSuccess(i18n.t('GENERIC.SAVE_SUCCESSFUL') as string, this);
              this.closeDetailModal();
              this.$emit("customer-updated", this.customer.numericId);
            } else {
              this.loading = false;
            }
          } else {
              await this.insertCustomerDo(false);
          }
        }
      } else {
        General.showAlertDanger(i18n.t('GENERIC.CHECK_MANDATORY_FIELDS') as string, this);
      }
    }
  }

  async nextStep(isRefuse: boolean = false, previousStep: boolean = false) {
    this.refuseContract = isRefuse;
    this.previousStep = previousStep;
    if(isRefuse) {
      this.nextStepModalTitle = i18n.t("NET20.CONTRACT_REFUSE") as string;
      if(this.customer.id != null)
          this.openModalNextStep();
    } else  {
      let isValidServiceData = await this.isValidServicesData();

      if(previousStep){
        this.nextStepModalTitle = i18n.t("NET20.CONTRACT_PREVIOUS_STEP") as string;
      } else {
        this.nextStepModalTitle = i18n.t("NET20.CONTRACT_NEXT_STEP") as string;
      }
      this.isSaveClicked = true;

      if(!isValidServiceData) {
        this.tabActivated = 0;
        General.showAlertDanger(i18n.t('NET20.SERVICE_MANDATORY') as string, this);
      }
      else if(!this.isValidAttachmentData(this.selectedContract, this.selectedContract.attachments, this.attachmentUpload, false)) {
        this.tabActivated = 1;
        General.showAlertDanger(i18n.t('NET20.ATTACHMENTS_MANDATORY') as string, this);
      }
      else {
        let isValidForm = await this.isValidForm();
        if(isValidForm) {
          if(await this.showWarningLimits() && !this.checkBypassValidation()) {
              General.showAlertDanger(i18n.t('NET20.POTENTIAL_VOLUME_WARNING') as string, this);
          } else {
            if(this.customer.id != null) {
              this.openModalNextStep();
            } else {
                await this.insertCustomerDo(true);
            }
          }
        } else {
          General.showAlertDanger(i18n.t('GENERIC.CHECK_MANDATORY_FIELDS') as string, this);
        }
      }
    }
  }

  async insertCustomerDo(proceedToApproval: boolean = false) {
    var message = proceedToApproval ? i18n.t('GENERIC.CONFIRM_MESSAGE') as string : i18n.t('NET20.MSG_CONFIRM_INSERT_CUSTOMER_DRAFT') as string;
    General.confirm(
      message,
      this,
      async () => {
        await this.insertCustomer(proceedToApproval);
      }
    );
  }

  async showWarningLimits() {
    let check = await IsPotentialVolumeCompliant(this.customer.idCountry, this.selectedContract.idChannel, this.selectedContract.typeOfProposal, this.selectedContract.potentialVolume)
    return !check;
  }

  async insertCustomer(proceedToApproval: boolean = false) {
    try {
      this.loading = true;
      this.$emit("onExecutingAction");
      let response = await axios.post(General.GetApiUrl('/api/net20/CreateCustomer')
                                      ,this.customer
                                      ,{ withCredentials: true });
      if(response.data != null) {
        let numericId: string = response.data;
        this.selectedContract.idCustomer = await this.getCustomerIdByNumericId(numericId);
        this.selectedContract.id = await this.insertContract(proceedToApproval);
        if(this.selectedContract.id != null) {
          this.selectedContract.attachments.forEach(element => {
            element.uploadContractStep = STEP_ENUM.EVALUATION_FORM
          });
          await this.updateAttachments(this.selectedContract.attachments, this.selectedContract.id);
        }

        General.showAlertSuccess(i18n.t('NET20.CUSTOMER_CREATED') as string, this);
        this.isSaveClicked = false;
        this.closeDetailModal();
        this.$emit("customer-created", numericId);
      }
    } catch (error) {
      if((error.response.data as string).toLowerCase().includes("vat number")) {
        General.showAlertDanger(i18n.t('NET20.VAT_NUMBER_USED') as string, this);
      } else {
        General.HandleError(error, this);
      }
    } finally {
      this.loading = false;
    }
  }

  async insertContract(proceedToApproval: boolean = false) {
    if(this.selectedContract != null) {
      let endpointUrl = proceedToApproval ? "/api/net20/CreateCustomerContract?proceedToNextStep=true" : "/api/net20/CreateCustomerContract";
      let response = await axios({
          method: "post",
          url: General.GetApiUrl(endpointUrl),
          data: this.selectedContract,
          withCredentials: true,
          responseType: "json",
        });
      return response.data;
    }
  }

  openModalNextStep() {
    this.$bvModal.show('contract-next-step');
  }
  closeModalNextStep() {
    this.$bvModal.hide('contract-next-step');
  }

  openModalRenewContract() {
    this.$bvModal.show('contract-renewal');
  }
  closeModalRenewContract() {
    this.$bvModal.hide('contract-renewal');
  }

  openModalEntityHistory() {
    this.$bvModal.show('customerData-history');
  }

  async renewContract(renewedContract: Contract) {
    try {
      if(!this.isValidAttachmentData(renewedContract, renewedContract.attachments, true, true)) {
        General.showAlertDanger(i18n.t('NET20.ATTACHMENTS_MANDATORY') as string, this);
      } else {
        if(this.isValidCustomerContractData(renewedContract, true))
        {
          this.closeModalRenewContract();
          this.loading = true;
          this.$emit("onExecutingAction");

          let response = await axios.post(General.GetApiUrl('/api/net20/RenewContract')
                                          ,renewedContract
                                          ,{ withCredentials: true });
          if(response.data != null) {
            await this.updateAttachments(renewedContract.attachments, response.data);
            General.showAlertSuccess(i18n.t('NET20.CONTRACT_RENEWAL_SUCCESS') as string, this);
            this.isSaveClicked = false;
            this.loading = false;
            this.closeDetailModal();
            this.$emit("customer-updated", this.customer.numericId);
          }
        } else {
          General.showAlertDanger(i18n.t('GENERIC.CHECK_MANDATORY_FIELDS') as string, this);
        }
      }
    } catch (error) {
      if((error.response.data as string).toLowerCase().includes("active")) {
        General.showAlertDanger(i18n.t('NET20.CONTRACT_YEAR_EXISTS') as string + renewedContract.contractYear, this);
      } else {
        General.HandleError(error, this);
      }
    } finally {
      this.loading = false;
    }
  }

  async nextStepEvent(step: ContractStep) {
    General.confirm(
      i18n.t('GENERIC.CONFIRM_MESSAGE') as string,
      this,
      async () => {
        this.closeModalNextStep();
        await this.goToNextStep(step);
      }
    );
  }

  async goToNextStep(step: ContractStep) {
    try {
      this.loading = true;
      this.$emit("onExecutingAction");

      if(!this.refuseContract) {
        await this.updateNet20Entities();
        this.nextStepCascadingOperation(step);
      }

      await this.insertNextStep(step);

      General.showAlertSuccess(i18n.t('GENERIC.SAVE_SUCCESSFUL') as string, this);

      this.isSaveClicked = false;
      this.closeDetailModal();

      this.$emit("customer-updated", this.customer.numericId);
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  async updateNet20Entities(): Promise<boolean> {
    let vatNumberError = await this.updateCustomer();
    if(vatNumberError) {
      General.showAlertDanger(i18n.t('NET20.VAT_NUMBER_USED') as string, this);
    } else {
      let isAdminNet20 = General.CheckAuthorization(ClaimEnum.CanAdminNet20);
      if(isAdminNet20) {
        await this.updateContract();
        await this.updateAttachments(this.selectedContract.attachments, this.selectedContract.id);
      } else {
        if(this.selectedContract.idStep == STEP_ENUM.EVALUATION_FORM
            || this.selectedContract.idStep == STEP_ENUM.CONTRACT_UPLOAD) {
          await this.updateContract();
          await this.updateAttachments(this.selectedContract.attachments, this.selectedContract.id);          
        } else if((this.selectedContract.idStep == STEP_ENUM.SIGNAGE_ORDER
                    || this.selectedContract.idStep == STEP_ENUM.INSTALLED_SIGNAGE) && this.attachmentUpload) {
          await this.updateAttachments(this.selectedContract.attachments, this.selectedContract.id);
          if(this.selectedContract.idStep == STEP_ENUM.INSTALLED_SIGNAGE) 
            await this.updateContractSignInstallationInfo();
        } else if(this.selectedContract.idStep == STEP_ENUM.SIGNAGE_ORDER) {
          if(this.contractInfoEditable)
            await this.updateContract();
          else if(this.contractSignInfoEditable)
            await this.updateContract(true);
        }
      }
    }
    return vatNumberError;
  }

  nextStepCascadingOperation(step: ContractStep) {
    step.currentVersion = this.selectedContract.currentVersion;
  }

  async updateCustomer() {
    let vatNumberError: boolean = false
    try {
      await axios.post(General.GetApiUrl('/api/net20/UpdateCustomer')
                                      ,this.customer
                                      ,{ withCredentials: true });
    } catch (error) {
      if((error.response.data as string).toLowerCase().includes("vat number"))
        vatNumberError = true;
    }
    return vatNumberError;
  }

  async updateContract(updateSignInfo: boolean = false) {
    let endpointUrl = updateSignInfo ? "/api/net20/UpdateCustomerContract?updateSignInfo=true" : "/api/net20/UpdateCustomerContract";
    if(this.selectedContract != null) {
      let response = await axios({
        method: "post",
        url: General.GetApiUrl(endpointUrl),
        data: this.selectedContract,
        withCredentials: true,
        responseType: "json",
      });
      if(response.data)
        this.selectedContract.currentVersion = response.data;
    }
  }

  async updateContractSignInstallationInfo() {
    let endpointUrl = "/api/net20/UpdateCustomerContractSignInstallationInfo";
    if(this.selectedContract != null) {
      let response = await axios({
        method: "post",
        url: General.GetApiUrl(endpointUrl),
        data: this.selectedContract,
        withCredentials: true,
        responseType: "json",
      });
      if(response.data)
        this.selectedContract.currentVersion = response.data;
    }
  }

  async insertNextStep(step: ContractStep) {
    if(this.selectedContract != null) {
        await axios({
          method: "post",
          url: General.GetApiUrl("/api/net20/ChangeCustomerContractStep"),
          data: step,
          withCredentials: true,
          responseType: "json",
        });
      }
  }

  async getCustomerIdByNumericId(numericId: string) {
          let idCustomer: string = null;

          try {
              let response = await axios({
                  method: 'get',
                  url: General.GetApiUrl('/api/net20/GetCustomerIdByNumericId?numericId=' + numericId),
                  responseType: 'json',
                  withCredentials: true
              });
              idCustomer = response.data;
          } catch (error) {
              General.HandleError(error, this);
          }
          return idCustomer;
      }

  closeDetailModal() {
    this.$bvModal.hide("customer-details-modal");
  }

  async onCalculatingScore() {
    if(this.selectedContract.idStep == STEP_ENUM.EVALUATION_FORM
        || this.selectedContract.idStep == STEP_ENUM.SIGNAGE_ORDER)
      await this.calculateScore();
  }
  
  async calculateScore() {
      this.loadingScore = true;
      let customerToSend = {...this.customer};
      customerToSend.contracts = null;
      customerToSend.contracts = [{...this.selectedContract}]
      this.convertNotNullableValue(customerToSend.contracts[0]);
      let response = await axios.post(General.GetApiUrl('/api/net20/CalculateScore')
                                        ,customerToSend
                                        ,{ withCredentials: true });
      if(response.data != null) {
        this.customer.assessmentScore = response.data
        this.loadingScore = false;
      }    
  }

  convertNotNullableValue(contract: Contract) {
    if(contract.idChannel == null)
      contract.idChannel = 0;
  }

  async isValidForm() {
    let validCustomerData = await this.isValidCustomerData();
    let validCustomerContractData = this.isValidCustomerContractData(this.selectedContract);
    if(!validCustomerData){
      this.tabActivated = 0;
    } else if(!validCustomerContractData){
      this.tabActivated = 1;
    }
    return validCustomerData && validCustomerContractData;
  }

  async checkCountryWithDistricts(idCountry: string) {
      var districts = await GetDistricts(idCountry);
      return districts.length > 0;
  }

  async isValidCustomerData() {
    if(this.fieldConfigurations == null || this.fieldConfigurations.length == 0)
      this.fieldConfigurations = await GetFieldConfigurations(this.customer.idCountry);
    
    if(this.isCountryWithDistricts == null)
      this.isCountryWithDistricts = await this.checkCountryWithDistricts(this.customer.idCountry);

    let isValid: boolean = true;
    if(!this.checkBypassValidation()) {
        if(this.CheckIsNullOrEmpty(this.customer.workshopName)
          || this.CheckIsNullOrEmpty(this.customer.vatNumber)
          || this.CheckIsNullOrEmpty(this.customer.locationAddress)
          || this.CheckIsNullOrEmpty(this.customer.idCountry)
          || this.CheckIsNullOrEmpty(this.customer.city)
          || this.CheckIsNullOrEmpty(this.customer.postCode)
          || (this.isCountryWithDistricts ? this.CheckIsNullOrEmpty(this.customer.idDistrict) : this.CheckIsNullOrEmpty(this.customer.district))
          || this.CheckIsNullOrEmpty(this.customer.ownersName)
          || this.CheckIsNullOrEmpty(this.customer.email)
          || (this.CheckIsNullOrEmpty(this.customer.telephone) && this.CheckIsNullOrEmpty(this.customer.mobile)
          || (this.CheckIsNullOrEmpty(this.customer.welcomeKitSize) && this.isMandatoryFieldNet20('welcomeKitSize'))
          //LOCATION SECTION
          || (this.CheckIsNullOrEmpty(this.customer.idWorkshopArea) && this.isMandatoryFieldNet20('idWorkshopArea'))
          || (this.CheckIsNullOrEmpty(this.customer.idTrafficFlow) && this.isMandatoryFieldNet20('idTrafficFlow'))
          || (this.CheckIsNullOrEmpty(this.customer.workshopVisibility) && this.isMandatoryFieldNet20('workshopVisibility'))
          || (this.CheckIsNullOrEmpty(this.customer.idWorkshopAppearance) && this.isMandatoryFieldNet20('idWorkshopAppearance'))
          || (this.CheckIsNullOrEmpty(this.customer.mqTotal) && this.isMandatoryFieldNet20('mqTotal'))
          || (this.CheckIsNullOrEmpty(this.customer.entrancesNumber) && this.isMandatoryFieldNet20('entrancesNumber'))
          || (this.CheckIsNullOrEmpty(this.customer.exFCAWorkshop) && this.isMandatoryFieldNet20('exFCAWorkshop'))
          || (this.CheckIsNullOrEmpty(this.customer.waitingRoom) && this.isMandatoryFieldNet20('waitingRoom'))
          || (this.CheckIsNullOrEmpty(this.customer.workersNumber) && this.isMandatoryFieldNet20('workersNumber'))
          || (this.CheckIsNullOrEmpty(this.customer.carBrigdgeLifterNumber) && this.isMandatoryFieldNet20('carBrigdgeLifterNumber'))
          || (this.CheckIsNullOrEmpty(this.customer.increasingBridgeLifter) && this.isMandatoryFieldNet20('increasingBridgeLifter'))
          || (this.CheckIsNullOrEmpty(this.customer.warehouse) && this.isMandatoryFieldNet20('warehouse'))
          || (this.CheckIsNullOrEmpty(this.customer.signage) && this.isMandatoryFieldNet20('signage'))
          || (this.CheckIsNullOrEmpty(this.customer.signHighTrafficStreet) && this.isMandatoryFieldNet20('signHighTrafficStreet'))
          
          //TRAINING SECTION
          || (this.CheckIsNullOrEmpty(this.customer.trainingParticipation) && this.isMandatoryFieldNet20('trainingParticipation'))
          || (this.customer.trainingParticipation != null && this.customer.trainingParticipation.toString() === 'true' && 
              (this.CheckIsNullOrEmpty(this.customer.idTrainingType)
                || this.CheckIsNullOrEmpty(this.customer.trainingProvidedBy)
                || this.CheckIsNullOrEmpty(this.customer.idTrainingPerYear)))
          //OTHER INFO SECTION
          || (this.CheckIsNullOrEmpty(this.customer.consumerReview) && this.isMandatoryFieldNet20('consumerReview'))
          || (this.CheckIsNullOrEmpty(this.customer.advertInvestments) && this.isMandatoryFieldNet20('advertInvestments'))
          || (this.CheckIsNullOrEmpty(this.customer.digitalPlatform) && this.isMandatoryFieldNet20('digitalPlatform'))
          || (this.CheckIsNullOrEmpty(this.customer.petronasDigitalPlatform) && this.isMandatoryFieldNet20('petronasDigitalPlatform'))
          // VAT NUMBER VALIDATION
          || !this.validateVatNumber(this.customer.vatNumber, this.customer.idCountry)
          )
      ) {
        isValid = false;
      }
    }

    return isValid;
  }

  isValidCustomerContractData(contract: Contract, isRenewal: boolean = false) {
    let isValid: boolean = true;
    if(isRenewal && this.CheckIsNullOrEmpty(contract.contractYear)
      || this.CheckIsNullOrEmpty(contract.idChannel)
      || this.CheckIsNullOrEmpty(contract.typeOfProposal)
      || this.CheckIsNullOrEmpty(contract.potentialVolume)
      || this.CheckIsNullOrEmpty(contract.actualVolume)
      // || this.CheckIsNullOrEmpty(contract.actualSupplier)
      // || this.CheckIsNullOrEmpty(contract.financialRisk)
      || this.CheckIsNullOrEmpty(contract.signCustomization)
      || this.CheckIsNullOrEmpty(contract.signType)
      || this.CheckIsNullOrEmpty(contract.signSize)
      || (this.CheckIsNullOrEmpty(contract.signNameText) && !contract.silverTypeOfProposal)
      || this.CheckIsNullOrEmpty(contract.signBrandCustomization)
      || (contract.idStep == STEP_ENUM.INSTALLED_SIGNAGE && this.CheckIsNullOrEmpty(contract.signInstalled))
    ) {
      isValid = false;
    }

    return isValid;
  }

  async isValidServicesData() {
    if(this.fieldConfigurations == null || this.fieldConfigurations.length == 0)
      this.fieldConfigurations = await GetFieldConfigurations(this.customer.idCountry);
    
    let check: boolean = true;
    if(!this.checkBypassValidation() && this.isMandatoryFieldNet20('services')) {
      if(this.customer.services == undefined || this.customer.services.length == 0)
        check = false;
    }
    return check;
  }

  isValidAttachmentData(contract: Contract, attachments: Array<ContractAttachment>, canAttachFile: boolean, isRenewal: boolean = false) {
    if(canAttachFile
      && (contract.idStep == STEP_ENUM.EVALUATION_FORM
        || contract.idStep == STEP_ENUM.CONTRACT_UPLOAD
        || contract.idStep == STEP_ENUM.INSTALLED_SIGNAGE))
        if(isRenewal) {
          return attachments != null && attachments.filter(a => !a.toDelete).length > 0;
        } else {
          let deltaFilesCounter = attachments.filter(x => !x.toDelete && (x.id === undefined || x.id == null) && x.sessionId != null).length;
          let filesUploadedInCurrentStep = attachments.filter(x => !x.toDelete && x.id != null && x.uploadContractStep == contract.idStep).length

          if(contract.idStep == STEP_ENUM.EVALUATION_FORM) {
            return attachments != null 
                      && (this.isRedoingStep(STEP_ENUM.EVALUATION_FORM) 
                        || (!this.isRedoingStep(STEP_ENUM.EVALUATION_FORM) && (deltaFilesCounter > 0 || filesUploadedInCurrentStep > 0)))
                      && attachments.filter(a => !a.toDelete).length >= 1;
          } else if(contract.idStep == STEP_ENUM.CONTRACT_UPLOAD) {
            return attachments != null 
                      && (this.isRedoingStep(STEP_ENUM.CONTRACT_UPLOAD) 
                        || (!this.isRedoingStep(STEP_ENUM.CONTRACT_UPLOAD) && (deltaFilesCounter > 0 || filesUploadedInCurrentStep > 0)))
                      && attachments.filter(a => !a.toDelete).length >= 2;
          } else if(contract.idStep == STEP_ENUM.INSTALLED_SIGNAGE) {
            return attachments != null 
                      && (this.isRedoingStep(STEP_ENUM.INSTALLED_SIGNAGE) 
                        || (!this.isRedoingStep(STEP_ENUM.INSTALLED_SIGNAGE) && (deltaFilesCounter > 0 || filesUploadedInCurrentStep > 0)))
                      && ((this.customer.excludedContractSteps.map(x => x.idStep).includes(STEP_ENUM.CONTRACT_UPLOAD) && attachments.filter(a => !a.toDelete).length >= 2) || attachments.filter(a => !a.toDelete).length >= 3);
          }
        }
    else
      return true;
  }

  isRedoingStep(idStep: number) {
    let counter = this.selectedContract.steps.filter(x => x.idStep == idStep).length;
    if(counter > 1 && this.selectedContract.idStep == idStep)
      return true;
    else
      return false;
  }

  checkBypassValidation(): boolean {
    let check = false;
    if(this.customer.imported && this.selectedContract.idStep > STEP_ENUM.EVALUATION_FORM)
      check = true;
    return check;
  }

  CheckIsNullOrEmpty(text: any) {
    if (text == null) return true;
    if (text.toString() === '') return true;
    return false;
  }

  validateVatNumber(vatNumber: string, idCountry: string) {
    let check: boolean = true;
    let regexPattern = this.getVatNumberRuleByCountry(idCountry);
    if(regexPattern != null) {
        const regex = new RegExp(regexPattern);

        if (!regex.test(vatNumber)) {
            check = false;
        }
    }
    return check;
  }

  getVatNumberRuleByCountry(idCountry) {
    let regexPattern: string = null;
    if(idCountry != null) {
        let country = this.countryListData.find(c => c.idCountry == idCountry);

        if (country && country.vatNumberRule != null)
            regexPattern = country.vatNumberRule.regex;
    }
    return regexPattern;
  }

  isMandatoryFieldNet20(field: string) {
    return IsMandatoryField(this.fieldConfigurations, field, this.customer.idCountry);
  }
}
